module.exports = __webpack_public_path__ + "img/plus_transparent.ab7ead8c.svg";